import React from 'react';
import { SuitDivider } from './SuitDivider';
import { SectionReveal } from './SectionReveal';
interface ProblemCardProps {
  suit: string;
  title: string;
  description: string;
  suitColor: string;
}
function ProblemCard({
  suit,
  title,
  description,
  suitColor
}: ProblemCardProps) {
  return <div className="relative p-6 md:p-8 group" data-id="element-147">
      {/* Gold border */}
      <div className="absolute inset-0 border border-goldenrod/30" data-id="element-148" />
      {/* Corner accents */}
      <div className="deco-corner-tl" data-id="element-149" />
      <div className="deco-corner-tr" data-id="element-150" />
      <div className="deco-corner-bl" data-id="element-151" />
      <div className="deco-corner-br" data-id="element-152" />

      {/* Suit icon */}
      <div className={`text-4xl md:text-5xl mb-6 ${suitColor} opacity-60 select-none`} aria-hidden="true" data-id="element-153">
        {suit}
      </div>

      <h3 className="font-display text-xl md:text-2xl text-ivory uppercase tracking-[0.15em] mb-4" data-id="element-154">
        {title}
      </h3>

      <p className="font-body text-ivory/80 text-lg leading-relaxed" data-id="element-155">
        {description}
      </p>
    </div>;
}
export function ProblemSalon() {
  return <section className="relative bg-deep-green py-24 md:py-32" data-id="element-156">
      <div className="max-w-6xl mx-auto px-6" data-id="element-157">
        <SectionReveal data-id="element-158">
          {/* Section header */}
          <div className="text-center mb-16" data-id="element-159">
            <h2 className="font-display text-3xl md:text-4xl lg:text-5xl text-goldenrod uppercase tracking-[0.3em] mb-4" data-id="element-160">
              The Problem Salon
            </h2>
            <p className="font-body text-goldenrod/70 italic text-lg tracking-wide" data-id="element-161">
              Adversarial Cartography
            </p>
            <SuitDivider className="mt-8 max-w-md mx-auto" data-id="element-162" />
          </div>

          {/* Problem cards */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-6 lg:gap-10" data-id="element-163">
            <ProblemCard suit="♠" suitColor="text-goldenrod" title="Static Equilibria" description="Conventional GTO solvers produce rigid, pre-computed strategies. They cannot adapt in real-time to shifting opponent behavior, leaving exploitable patterns in dynamic play." data-id="element-164" />
            <ProblemCard suit="♥" suitColor="text-crimson" title="Isolated Decisions" description="Existing tools treat each street as an independent problem. Without multi-street modeling, they fail to capture the cascading consequences that define deep strategic play." data-id="element-165" />
            <ProblemCard suit="♣" suitColor="text-goldenrod" title="Brittle Strategies" description="Strategies built on static assumptions collapse against adaptive opponents. When the adversary evolves, these systems have no mechanism to evolve in response." data-id="element-166" />
          </div>
        </SectionReveal>
      </div>
    </section>;
}